import clsx from 'clsx'
import { useFormik } from 'formik'
import React, { useEffect, useState } from 'react'
import { Link, useHistory } from 'react-router-dom'
import * as Yup from 'yup'
import '../masters/basic.css'
import httpService from '../../setup/http/httpServices'
import { Input, message } from 'antd'
import Select from 'react-select'
import loc from '../data/Location.json'
import { AddWebsiteLeftBreadcrum } from './AddWebsiteLeftBreadcrumb'
import { toAbsoluteUrl } from '../../_metronic/helpers'
import ScreenshotsComponent from '../masters/ScreenshotsComponent'
import { ChromePicker } from 'react-color'
import rgbHex from 'rgb-hex'
import { handleFileUpload } from '../../setup/Upload/Upload'

var initialValues = {
  // agencyAssociated: '',
  websiteURL: '',
  // desktopScreenshots: ['test.png'],
  // mobileScreenshots: ['test.png'],
  // colors: [''],
  // gstNumber: '',
  // companyDescription: '',
  // companyContactPerson: '',
  // companyEmail: '',
  // companyPhoneNumber: '',
  // companyWebsite: '',
  // companyBillingAddress: '',
  // companyCity: '',
  // companyState: '',
  // companyPinCode: '',
}
const regex = /[a-zA-Z]/
const registrationSchema = Yup.object().shape({
  websiteURL: Yup.string()
    .required('URL is required')
    .matches(
      /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)/,
      'Must be a URL'
    ),
  // desktopScreenshots: Yup.array()
  // .min(1,"Should have atleast 1 screenshot")
  // .required('Screenshot Required'),
  // mobileScreenshots: Yup.array()
  // .min(1,"Should have atleast 1 screenshot")
  // .required('Screenshot Required'),
  // colors: Yup.array()
  // .min(2,"Should have atleast 2 colors")
  // .required('Colors Required'),
  // gstNumber: Yup.string()
  //   .min(15, 'Minimum 15 digits')
  //   .max(15, 'Maximum 15 digits')
  //   .required('GST Number is required'),
  // companyDescription: Yup.string()
  //   .min(3, 'Minimum 3 characters')
  //   .max(500, 'Maximum 500 characters')
  //   .required('Description is required'),
  // companyContactPerson: Yup.string()
  //   .min(3, 'Minimum 3 symbols')
  //   .max(50, 'Maximum 50 symbols')
  //   .required('Contact Person is required')
  //   .matches(/^(?=[^A-Za-z\n]*[A-Za-z])[A-Za-z._-]*[A-Za-z0-9._ -]*$/,"Must be alphanumeric"),
  // companyEmail: Yup.string()
  //   .email('Wrong format of Email')
  //   .matches(
  //     /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  //     'Wrong format of Email'
  //   )
  //   .min(3, 'Minimum 3 symbols')
  //   .max(50, 'Maximum 50 symbols')
  //   .required('Email is required'),
  // companyPhoneNumber: Yup.string()
  //   .min(10, 'Minimum 10 digits')
  //   .max(12, 'Maximum 13 digits with country code')
  //   .required('Phone Number is required'),
  // companyWebsite: Yup.string()
  //   .matches(
  //     /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/gi,
  //     'Wrong format of URL'
  //   )
  //   .min(3, 'Minimum 3 symbols')
  //   .max(500, 'Maximum 500 symbols')
  //   .required('Website is required'),
  // companyBillingAddress: Yup.string().min(3, 'Minimum 3 symbols').max(500, 'Maximum 500 symbols'),
  // companyPinCode: Yup.string().min(6, 'Minimum 6 digit').max(6, 'Maximum 6 digit'),
})

export function AddWebsiteAssociatedPages() {
  const history: any = useHistory()
  const [loading, setLoading] = useState(false)
  const [counter, setCounter] = useState(Array(1).fill(0))
  const [values, setValues] = useState([
    {
      Category: { value: '', label: 'Select Category' },
      PageLink: '',
      AssociatedPageDesktopSS: '',
      AssociatedPageMobileSS: ''
    },
  ])
  const [pages, setPages] = useState([{ value: '', label: 'Select Framework' }])
  const [page, setPage] = useState({ value: '', label: 'Select Framework' })
  const [errors, setErrors] = useState<any>([{ Category: '', PageLink: '' }])

  const [selectedDesktopSS, setSelectedDesktopSS] = useState<any>([])
  const [selectedMobileSS, setSelectedMobileSS] = useState<any>([])

  const  onChange = async(event: any, index: number) => {
    const d = await handleFileUpload(event);
    const arr = [...values];
    arr[index].AssociatedPageDesktopSS = d
    setValues(arr)
  }
  
  const onChangeMob = async(event: any, index: number) => {
    const d = await handleFileUpload(event);
    const arr = [...values];
    arr[index].AssociatedPageMobileSS = d
    setValues(arr)
  }

  const formik = useFormik({
    initialValues: initialValues,
    // validationSchema: registrationSchema,
    enableReinitialize: true,
    onSubmit: (v, { setStatus, setSubmitting }) => {
      setLoading(true)
      console.log('idhar')
      console.log(values);
      let tempErr = []
      console.log(tempErr)

      const urlReg = new RegExp(
        /^(https?:\/\/)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_\+.~#?&//=]*)$/
      )
      let count = 0
      values.forEach((value, i) => {
        if (value?.Category.value === '') {
          tempErr[i] = { Category: 'required', PageLink: '' }
          count++
        } else if (value?.PageLink === '') {
          tempErr[i] = { Category: '', PageLink: 'required' }
          count++
        } else if (!value?.PageLink.match(urlReg)) {
          tempErr[i] = { Category: '', PageLink: 'Must be a URL' }
          count++
        }
        // else if(!values.DesktopSS){
        //   tempErr[i] = { Category: '', PageLink: 'Must be a URL' }
        // }
        else {
          tempErr[i] = { Category: '', PageLink: '' }
        }
        console.log(tempErr)
      })

      setErrors(tempErr)

      // let x = {}

      // let obj = {id:null,Name:""}
      // values.forEach(value=>{
      //   obj = {id:value.Category.value,Name:values.Category.label}

      // })

      // let x = [...values]
      // x.Category={id:values.}
      // const arr = []
      // const arr2 = []
      // for (const i of values) {
      //   console.log(i);
        
      //   arr.push(i.DesktopSS[0])
      //   arr2.push(i.mobileSS[0])
      // }
      // console.log('arr', arr);
      // console.log('arr2', arr2);


      console.log('values', history.location.state)
      const fd = {
        id: history.location.state.id,
        AssociatedPages: values,
      }

      // fd.append('AssociatedPageDesktopSS[]', JSON.stringify(arr))
      // fd.append('AssociatedPageMobileSS', JSON.stringify(arr2))

      // const arr3 = values.map(item => {return item.DesktopSS})
      // const arr4 = values.map(item => {return item.DesktopSS})
      if (count === 0) {
        httpService.patchData(
          '/website/update/?step=5',
          fd,
          (res) => {
            console.log(res)
            setLoading(false)

            history.push({
              pathname: '/addWebsite/associated-components',
              state: {
                ...history.location.state,
                values,
              },
            })
          },
          (err) => {
            setLoading(false)

            console.log(err)
          }
        )
      } else {
        setLoading(false)
      }

      // setLoading(true)
      // setTimeout(() => {
      //   try {
      //     // let request: any = values;
      //     // request.agencyAssociated = agencyAssociated;
      //     setLoading(false)
      //     setSubmitting(false)
      //     history.push({
      //       pathname: '/agencyDetails',
      //       state: {
      //         ...history.location.state,
      //         ...{companyDetails: values},
      //       },
      //     })
      //   } catch {
      //     setLoading(false)
      //     setSubmitting(false)
      //     setStatus('Registration process has broken')
      //     // Remove logs when not needed
      //   }
      // }, 1000)
    },
  })
  useEffect(() => {
    console.log(history)
    httpService.getData(
      '/pages-master',
      (res) => {
        console.log(res)
        console.log(res.data.data.data)
        let x = []
        res.data.data.data.forEach((data) => {
          x.push({ value: data._id, label: data.Name })
        })
        // console.log(frameworks);

        setPages(x)
        // setCategories(res.data.data.data)
      },
      (err) => {
        message.error('Not able to fetch.')
      }
    )

    if(history.location.state.edit){
      console.log('here m',history.location.state);
      
      setValues(history.location.state.website.AssociatedPages)
      setCounter(history.location.state.website.AssociatedPages)
    }
  }, [])

  // useEffect(() => {
  //   // setCounter(history.location.state.website.AssociatedPages.length===0?Array(1).fill(0):Array(history.location.state.website.AssociatedPages.length).fill(0))
  //   let x = [...history.location.state.website[0].AssociatedPages]

  //   if (x.length !== 0) {
  //     x.forEach((a) => {
  //       let y = a.Category
  //       a.Category = y
  //     })
  //     setValues(x)
  //     formik.setFieldValue('websiteURL', x[0].PageLink)
  //     setCounter(Array(history.location.state.website.AssociatedPages?.length).fill(0))
  //     setErrors(
  //       Array(history.location.state.website.AssociatedPages?.length).fill([
  //         {Category: '', PageLink: ''},
  //       ])
  //     )
  //   }

  //   // setSelectedCategories(history.location.state.website.Categorys)
  // }, [history])

  const deletePage = (i) => {
    let temp = [...counter]
    temp.splice(i, 1)
    setCounter(temp)
    let tempV = [...values]
    tempV.splice(i, 1)
    setValues(tempV)
    let tempX = [...errors]
    tempX.splice(i, 1)
    setErrors(tempX)
  }

  const checkErr = () => {
    const urlReg = new RegExp(
      /^(https?:\/\/)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_\+.~#?&//=]*)$/
    )
    let tempErr = [...errors]

    values.forEach((value, i) => {
      if (value?.Category.value === '') {
        tempErr[i] = { Category: 'required', PageLink: '' }
      } else if (value?.PageLink === '') {
        tempErr[i] = { Category: '', PageLink: 'required' }
      } else if (!value?.PageLink?.match(urlReg)) {
        tempErr[i] = { Category: '', PageLink: 'Must be a URL' }
      } else {
        tempErr[i] = { Category: '', PageLink: '' }
      }
    })

    setErrors(tempErr)
  }
  const [nameError, setNameError] = useState(false)
  // const validateName = (name: any) => {
  //   httpService.getData(
  //     '/' + history.location.state?.type.toLowerCase() + '-master/',
  //     (res: any) => {
  //       if (history.location.state?.type == 'Agency') {
  //         htmlFor (var i = 0; i < res.data.data?.agencies.length; i++) {
  //           if (res.data.data?.agencies[i].companyDetails.websiteURL == name) {
  //             setNameError(true)
  //             break
  //           } else {
  //             setNameError(false)
  //           }
  //         }
  //       } else {
  //         htmlFor (var i = 0; i < res.data.data?.brands.length; i++) {
  //           if (res.data.data?.brands[i].companyDetails.websiteURL == name) {
  //             setNameError(true)
  //             break
  //           } else {
  //             setNameError(false)
  //           }
  //         }
  //       }
  //     },
  //     (err: any) => {}
  //   )
  // }

  return (
    <div className='CompanyDetailsOuter '>
      <AddWebsiteLeftBreadcrum currentStep='5' />
      <form
        className='CompanyDetails'
        noValidate
        id='kt_login_signup_form'
        onSubmit={formik.handleSubmit}
        style={{ marginBottom: '200px' }}
      >
        <h2 className=''>Associated Pages</h2>
        {counter.map((x, i) => {
          return (
            <div>
              <div className='row pt-4 pe-5 pb-5'>
                <div className='col '>
                  <h6 className='fw-bold required'>Select Page Category</h6>
                  <Select
                    isMulti={false}
                    // isDisabled = {history.location.state.id}
                    name='Page Category'
                    options={pages}
                    value={values[i]?.Category}
                    placeholder='Select Page Category'
                    styles={{
                      menuList: (provided, state) => ({
                        ...provided,
                        height: 'auto',
                        maxHeight: '200px',
                      }),
                    }}
                    onChange={(e) => {
                      console.log(e)
                      let x = [...values]
                      x[i].Category = e
                      setValues(x)
                      console.log(values)
                      checkErr()
                    }}
                    className={clsx(
                      'text-gray-500 form-control form-control-solid rounded-4 bg-gray-100 p-0 border-0 categorySelect'
                    )}
                  />
                  {errors[i]?.Category !== '' && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>
                        <span className='text-danger' role='alert'>
                          {errors[i]?.Category}
                        </span>
                      </div>
                    </div>
                  )}
                </div>

                <div className='col '>
                  <h6 className='fw-bold required'>Page Link</h6>
                  <Input
                    type='text'
                    placeholder='Enter Page Link'
                    value={values[i]?.PageLink}
                    onChange={(e) => {
                      let x = [...values]
                      x[i].PageLink = e.target.value

                      setValues(x)
                      console.log(values)
                      checkErr()
                    }}
                    style={{ height: '38px' }}
                    suffix={
                      <>
                        <img src={toAbsoluteUrl('/media/logos/link.svg')} alt='link' />
                      </>
                    }
                    className={clsx(
                      ' form-control-solid shadow-none border-0 rounded-4 bg-gray-100',
                      {
                        'is-invalid':
                          (formik.touched.websiteURL && formik.errors.websiteURL) || nameError,
                      },
                      {
                        'is-valid': formik.touched.websiteURL && !formik.errors.websiteURL,
                      }
                    )}
                  />
                  {errors[i]?.PageLink !== '' && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>
                        <span className='text-danger' role='alert'>
                          {errors[i]?.PageLink}
                        </span>
                      </div>
                    </div>
                  )}
                </div>
                <div className='col-1 d-flex align-items-center'>
                  <button
                    className='bg-gray-100 border-0 shadow-none rounded-4 px-3 py-3 mt-7'
                    type='button'
                    onClick={() => deletePage(i)}
                    style={{ height: '38px' }}
                  >
                    <img src={toAbsoluteUrl('/media/icons/Custom/Dustbin.svg')} alt='Delete'></img>
                  </button>
                </div>
              </div>
              <div>
                <div className="d-flex justify-content-between align-items-center mt-5">
                  <div>
                    <h6 className='required fw-normal'>Page Desktop Thumbnail </h6>
                    <p className='fw-normal' style={{ fontSize: '12px' }}>Desktop Screenshot Size: 1080x720</p>
                  </div>
                  <div className="d-flex gap-2 align-items-center">
                    <button type='button' className={
                      !(values[i]?.AssociatedPageDesktopSS)
                        ? 'btn btn-gray-200 screenshotComponentBtn border border-gray-500'
                        : 'screenshotComponentBtn'
                    }
                    onClick={() => {window.open(values[i]?.AssociatedPageDesktopSS, '_blank')}}
                    disabled={!values[i]?.AssociatedPageDesktopSS}
                    >
                      <img src={toAbsoluteUrl('/media/icons/Custom/eye.svg')} alt='eye' />  &nbsp; Preview
                    </button>
                    <button
                      onClick={() => {
                        document.getElementById('desktopss' + i).click()
                      }}
                      type='button'
                      className='btn btn-gray-200 screenshotComponentBtn border border-gray-500 w-200px mx-4 cursor-pointer'>
                      Click to Upload
                    </button>
                    <input
                      type='file'
                      accept='.png, .jpg, .jpeg, .svg'
                      style={{ display: 'none' }}
                      id={'desktopss' + i}
                      onChange={(e) => onChange(e, i)}
                    />
                  </div>
                </div>
                <div className="d-flex justify-content-between align-items-center mt-5">
                  <div>
                    <h6 className='required fw-normal'>Page Mobile Thumbnail </h6>
                    <p className='fw-normal' style={{ fontSize: '12px' }}>Mobile Screenshot Size: 250x100</p>
                  </div>
                  <div className="d-flex gap-2 align-items-center">
                    <button type='button' className={
                      !(values[i]?.AssociatedPageMobileSS)
                        ? 'btn btn-gray-200 screenshotComponentBtn border border-gray-500'
                        : 'screenshotComponentBtn'
                    }
                    onClick={() => {
                      window.open(values[i]?.AssociatedPageMobileSS,'_blank')
                    }}
                    disabled={!values[i]?.AssociatedPageMobileSS}
                    >
                      <img src={toAbsoluteUrl('/media/icons/Custom/eye.svg')} alt='eye' />  &nbsp; Preview
                    </button>
                    <button
                      onClick={() => {
                        document.getElementById('imagess' + i).click()
                      }}
                      type='button'
                      className='btn btn-gray-200 screenshotComponentBtn border border-gray-500 w-200px mx-4 cursor-pointer'>
                      Click to Upload
                    </button>
                    <input
                      type='file'
                      accept='.png, .jpg, .jpeg, .svg'
                      style={{ display: 'none' }}
                      id={'imagess' + i}
                      onChange={(e) => onChangeMob(e, i)}
                    />
                  </div>
                </div>
              </div>
            </div>
          )
        })}

        <div className='row pe-5 pb-5 '>
          <span
            className='fw-bold addpage'
            onClick={() => {
              let x = [...counter]
              x.push(0)
              setCounter(x)
              let y = [...values]
              y.push({ Category: { value: '', label: 'Select Category' }, PageLink: '', AssociatedPageDesktopSS: '', AssociatedPageMobileSS: '' })
              setValues(y)
              let z = [...errors]
              z.push({ Category: '', PageLink: '' })
              setErrors(z)
            }}
          >
            + Add Another Page
          </span>
        </div>

        <div className='d-flex pt-4 pe-5'>
          <button
            type='submit'
            id='kt_sign_up_submit'
            className='btn btn-primary ms-5 CompanyDetailButton'
            onClick={() => {
              console.log('kidhar')
            }}
            disabled={loading}
          >
            {!loading && <span className='indicator-label'>Next</span>}
            {loading && (
              <span className='indicator-progress' style={{ display: 'block' }}>
                Please wait...{' '}
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              </span>
            )}
          </button>
          <button onClick={() => {
            history.push({
              pathname: '/addWebsite/associated-components',
              state: {
                ...history.location.state,
                values,
              },
            })
          }} className='btn btn-primary ms-5 CompanyDetailButton'>
            <span className='indicator-label'>Skip</span>
          </button>
          <Link
            to={{
              pathname: '/addWebsite/tags',
              state: history.location.state,
            }}
          >
            <button type='button' className='btn fw-bolder btn-gray-200 ms-5 CompanyDetailButton'>
              Back
            </button>
          </Link>
        </div>
      </form>
    </div>
  )
}
